export const searchForTheCity = (city, limits) => {
    const regexp = new RegExp(city.replace(/(^\s+)|(\s+$)/g, ""), "i");
    return limits.filter((limit) => regexp.test(limit.name)).length;
};
//# sourceMappingURL=searchForTheCity.js.map